const SERVER_URL =
  "https://roundtechsquare-backend-production-2mk6mheziq-uc.a.run.app/user";

module.exports = { SERVER_URL };
